import createModel from "../createModel";
import { Claim } from "model/claim/Claim";

export const ClaimsEvents = createModel("ClaimsEvents", (json) => ({
    claims: Claim.fromServerList(json.claims),
    detailLink: json.claimsDetailLink,
    lifeClaimsDetailLink: json.lifeClaimsDetailLink,
    nonLifeClaimsDetailLink: json.nonLifeClaimsDetailLink,
}));
